import { createContext, useContext } from 'react';

export type DemoToggleState = 'before' | 'after';

type DemoToggleContextProps = {
  toggleState: DemoToggleState;
  setToggleState(state: DemoToggleState): void;
};

export const DemoToggleContext = createContext<
  DemoToggleContextProps | undefined
>(undefined);

export function useDemoToggle(): DemoToggleContextProps {
  const context = useContext(DemoToggleContext);

  if (!context) {
    throw new Error('useDemoToggle must be used within a DemoToggleProvider');
  }

  return context;
}
